export enum ROUTES {
  HOME = '/',
  DATA = '/data',
  PDGEOTHERMAL = '/pdgeothermal',
  PDOILFIELD = '/pdoilfield',
  WELLSGEOTHERMAL = '/wellsgeothermal',
  WELLSOILFIELD = '/wellsoilfield',
  NIR = '/nir',
  REFERENCES = '/references',
  CONTRIBUTE = '/contribute',
}
